import React from 'react';
import { Send, Phone, Mail } from 'lucide-react';

const CTA = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-[#006D77] to-[#008B8B] text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full blur-2xl"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full blur-2xl"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative max-w-3xl">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-3">
            Get in touch with us
          </h2>
          <p className="text-teal-100 text-sm md:text-base max-w-2xl mx-auto mb-6">
            MV/LV switchgear, distribution boards, VFDs, solar solutions, and site installations. 
            Contact our engineering team in Nairobi for a free consultation.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a 
              href="mailto:info@linearpowersystems.co.ke"
              className="bg-white text-[#006D77] px-6 py-2.5 rounded-full font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2 text-sm"
            >
              <Mail size={16} />
              Get a Quote
            </a>
            <a 
              href="tel:+254735338408" 
              className="border-2 border-white text-white px-6 py-2.5 rounded-full font-semibold hover:bg-white/10 transition-all flex items-center justify-center gap-2 text-sm"
            >
              <Phone size={16} />
              Call 0735 338 408
            </a>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-4 mt-4 text-teal-100 text-xs">
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 bg-teal-300 rounded-full"></span>
              Free Consultation
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 bg-teal-300 rounded-full"></span>
              Same-Day Response
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 bg-teal-300 rounded-full"></span>
              Expert Engineers
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 bg-teal-300 rounded-full"></span>
              Quality Guaranteed
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
